<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'
    import UPDATE from '../components/page/update.vue'
    import URL from '@/views/mis/util/url'
    import Qs from 'qs'
    import axios from 'axios'
    import DataUtil from '@/views/mis/util/data'
    import download from '@/utils/download'
    let verifyType = {1: "app视频认证", 2: "人脸识别"};
    let user = {};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created(){
            user = DataUtil.base.user();
        },
        methods: {
            checkbox(row) {
                this.deleteIds = row.map(key => key.id).join(",");
            },
            /*表格按钮点击事件*/
            bthClick(clickName, row) {
                if (clickName == "update") {
                    this.$refs.childUpdate.open(row);
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data) {
                if ("查询" == clickName  || window.$t('mis.bt.query') == clickName) {
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t('mis.bt.down') == clickName){
                    download.exportExcel(URL.face.download,data,window.$t('mis.faceConfig.faceRecord'));
                }
            },
            dataChanage(url, option, suc, fail) {
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {

                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data() {
            return {
                deleteIds: "",
                queryData: {},
                /*from查询表单*/
                formData: {
                    hasLable: true,
                    cols: [
                        {title: window.$t('mis.faceConfig.channelName'), field:'channelName'},
                        {title: window.$t('mis.faceConfig.verifyType'), field: 'type',type: 2, optionList: verifyType, isNumber: true},
                        {title: window.$t('mis.faceConfig.chineseName'), field: 'name'},
                        {title: window.$t('mis.faceConfig.card'), field: 'card'},
                        {title: window.$t('mis.faceConfig.phone'), field: 'phone'},
                        { title: window.$t('mis.common.startTime'), field: 'startTime',type:5},
                        { title: window.$t('mis.common.endTime'), field: 'endTime',type:5},
                        {click: window.$t('mis.bt.query')},
                        {click: window.$t('mis.bt.down')}
                    ]
                },
                /*table生成*/
                pageData: {
                    queryUrl: URL.face.recordQuery, //请求路径和参数
                    selection: true,
                    sequence: true,
                    cols: [
                        {title: window.$t('mis.faceConfig.chineseName'), field: 'name'},
                        {title: window.$t('mis.faceConfig.card'), field: 'card'},
                        {title: window.$t('mis.faceConfig.phone'), field: 'phone'},
                        {title: window.$t('mis.faceConfig.recordDate'), field: 'createDate'},
                        {title: window.$t('mis.faceConfig.verifyType'), field: 'type',render: (data, full) => {
                                return verifyType[data] || "";
                            }
                        },
                        {title: window.$t('mis.faceConfig.channelName'), field:'channelName'},
                        {title: window.$t('mis.faceConfig.result'), field: 'result'},
                        {title: window.$t('mis.faceConfig.resultParam'), field: 'resultParam'},
                    ]
                }
            }
        }
    }
</script>
